var cache = {};
var registry = {
    validatorTip: require('./jquery-validation-tip'),
    dataTables: require('./dataTables'),
    select2: require('select2/dist/js/select2.full.min'),
    WdatePicker: require('./wdatePicker/index')
};

/**
 * @description 根据插件名获取（初始化）插件，除了 pluginName 的剩余参数会传给对应的插件
 * @param pluginName :参见registry对象属性
 * @returns {*}
 */
module.exports = function (pluginName) {
    var plugin = null;
    if (pluginName in cache) {
        plugin = cache[pluginName];
    } else if (pluginName in registry) {
        plugin = cache[pluginName] = registry[pluginName].apply(null, [].slice.call( arguments, 1));
    }
    return plugin;
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/index.js
// module id = 199
// module chunks = 0